import { createAsyncThunk } from "@reduxjs/toolkit";
import * as reviewApi from "../../api/reviewApi";

export const getReviewerTypes = createAsyncThunk("reviews/getReviewerTypes",async (data) => {
        const res = await reviewApi.getReviewerTypes(data);
        return res.data;
    }
);

export const getProductReviews = createAsyncThunk("reviews/getProductReviews",async (filter) => { 
    const res = await reviewApi.getProductReviews(filter);
    return {
        data: res.data.data,
        start: filter.start || 0,
        length: filter.length || 4,
        isTypical: filter.isTypical || false
    };
    }
); 
